/* External Imports */
import { Box, Heading, Text } from '@chakra-ui/react';

//components
import config from '@config';
/* Styles */
import styles from '@lb/Sections/aboutDevi/styles.module.css';

const AboutDeviSlide2 = ({ section }) => {
  return (
    <Box
      background={{
        base: `#000 url(${config.imgPath}/d/46272/1684473634-ib_mob_secion2bg.jpg) no-repeat center top`,
        lg: `#000 url(${config.imgPath}/d/46272/1684474022-ib_secion2bg.png) no-repeat center center`,
      }}
      bgSize={{ base: 'contain', lg: 'cover' }}
      bgColor="#000"
      className={styles.section2Bg}
      p={{ base: 8, md: 10 }}
      overflow="hidden"
    >
      <Box
        maxW="1300px"
        display="flex"
        justifyContent={{ base: 'center', md: 'space-between' }}
        alignItems={{ base: 'start', md: 'center' }}
        flexDir={{ base: 'column', lg: 'row' }}
        minH="100vh"
        mx="auto"
      >
        <Box
          display="flex"
          px={{ base: 4, md: 0 }}
          width={{ base: '100%', sm: '30%', lg: '28%' }}
          flexWrap="wrap"
        >
          <Heading
            color="common.white"
            fontSize={{ base: '2rem', lg: '50px' }}
            fontFamily="'FedraSerifDisplay'"
            pl={{ base: '2.757rem' }}
            py="1rem"
          >
            {section?.sectionContent?.[0]?.data?.title1}
          </Heading>
          <Heading
            color="common.white"
            fontSize={{ base: '2.25rem', lg: '40px' }}
            fontFamily="'FedraSerifDisplay'"
            py="1rem"
          >
            {section?.sectionContent?.[0]?.data?.title2}
          </Heading>
          <Heading
            color="common.white"
            fontSize={{ base: '3rem', lg: '50px' }}
            fontFamily="'FedraSerifDisplay'"
            pl={{ base: '4rem', lg: 180 }}
            opacity="0.3"
            py="1rem"
          >
            {section?.sectionContent?.[0]?.data?.title3}
          </Heading>
          <Heading
            color="common.white"
            fontSize={{ base: '2.688rem', lg: '40px' }}
            fontFamily="'FedraSerifDisplay'"
            pl={{ base: 0, lg: '1rem' }}
            opacity="0.3"
            py="1rem"
            display={{ base: 'none', md: 'block' }}
          >
            {section?.sectionContent?.[0]?.data?.title4}
          </Heading>
          <Heading
            color="common.white"
            fontSize={{ base: '2.688rem', lg: '48px' }}
            fontFamily="'FedraSerifDisplay'"
            pl={{ base: '3rem', lg: '1rem' }}
            py="1rem"
            display={{ base: 'none', md: 'block' }}
          >
            {section?.sectionContent?.[0]?.data?.title5}
          </Heading>
          <Heading
            color="common.white"
            fontSize={{ base: '2.688rem', lg: '56px' }}
            fontFamily="'FedraSerifDisplay'"
            pl={{ base: '5rem', lg: '7rem' }}
            py="1rem"
            display={{ base: 'none', md: 'block' }}
          >
            {section?.sectionContent?.[0]?.data?.title6}
          </Heading>
        </Box>
        <Box
          width={{ base: '100%', sm: '19rem', md: '22rem', lg: '20rem' }}
          textAlign="right"
          alignItems="center"
          pt={{ base: '80px', lg: 0 }}
          px={{ base: 4, lg: 0 }}
        >
          <Heading
            color="common.white"
            fontSize={{ base: '4rem', lg: '80px' }}
            lineHeight={{ base: '4rem', lg: '90px' }}
            fontFamily="'FedraSerifDisplay'"
          >
            {section?.sectionContent?.[1]?.text}
          </Heading>

          <Text color="#FAEFE7" fontSize={{ base: '18px', lg: '24px' }}>
            {section?.sectionContent?.[2]?.text}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};
export default AboutDeviSlide2;
